import { observer } from 'mobx-react';
import { PermissionsHeaderColumn, PermissionsHeader, PermissionCells } from './PermissionStyle';
import React from 'react';
import { PropertiesTable } from '../../common-elements/fields-layout';

const viewerPermissionsAnnotation = 'x-viewer-permissions';

type PermissionsData = {
    actions?: string[];
    implicitActions?: string[];
};

export const getViewerPermissions = (props: any): PermissionsData | null => {
    if ('operationSpec' in props) {
        if ((viewerPermissionsAnnotation in props['operationSpec'])){
            let permissions = props['operationSpec'][viewerPermissionsAnnotation]
            if ('actions' in permissions) {
                if (Array.isArray(permissions['actions'])) {
                    return {
                        actions: permissions['actions']
                    };
                }
            }
        }
    }

    return null
};

export const getViewerImplicitPermissions = (props: any): PermissionsData | null => {
    if ('operationSpec' in props) {
        if ((viewerPermissionsAnnotation in props['operationSpec'])){
            let permissions = props['operationSpec'][viewerPermissionsAnnotation]
            if ('implicit-actions' in permissions) {
                if (Array.isArray(permissions['implicit-actions'])) {
                    return {
                        implicitActions: permissions['implicit-actions']
                    };
                }
            }
        }
    }

    return null
};

export const Permissions = observer((props: any) => {
    const enforcedPermissions = getViewerPermissions(props)?.actions??[]
    const implicitPermissions=getViewerImplicitPermissions(props)?.implicitActions??[]

    const permissions=[...enforcedPermissions,...implicitPermissions]

    if (permissions.length>0) {
        return (
            <PermissionsHeaderColumn>
                <PermissionsHeader>Permissions</PermissionsHeader>
                <PropertiesTable>
                    <tbody>
                        <tr>
                            <PermissionCells>
                                {permissions?.map(( action ) => (
                                    <li> { action } </li>
                                ))}
                            </PermissionCells>
                        </tr>
                    </tbody>
                </PropertiesTable>

            </PermissionsHeaderColumn>
        );
    } else {
      return (<></>);
    }
});
